import React from 'react';
import Slider from 'pap/components/common/slider_selector';

const SliderSelector = ({ options, input }) => {
  const value = [...(input.value || [])];
  return (
    <Slider
      options={options}
      value={value}
      onChange={(v, i) => { value[i] = v; input.onChange(value); }}
    />
  );
}

export default SliderSelector;
